import React from 'react';
import { Button, Form, Input, message, Row, Col } from 'antd';
import { FaFacebook, FaInstagram, FaTwitter, FaEnvelope } from 'react-icons/fa'; // Icons for social media
// import './Footer.css'; // Import the CSS file for styling
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS CSS

const Footer = () => {


  const [form] = Form.useForm();

  React.useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  }, []);

  // Handle form submission
  const handleSubmit = async (values) => {
    console.log(values)
    message.loading({ key:'contact-form', content: 'Submitting'});
    const response = await fetch('/api/mail', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values)
    })
    const result = await response.json()
    const { success, error } = result
    if (success) {
      message.success({ key:'contact-form', content: 'Form submitted successfully!' });
    } else {
      message.success({ key:'contact-form', content: error });
    }

    form.resetFields();
  };
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Quick Links Section */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
          </ul>
        </div>

        {/* Social Media Section */}
        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/magdiam0/" aria-label="Facebook">
              <FaFacebook className="icon" />
            </a>
            <a href="https://www.instagram.com/magdiam_1/" aria-label="Instagram">
              <FaInstagram className="icon" />
            </a>

            <a href="mailto:info@magdiam.com " aria-label="Email">
              <FaEnvelope className="icon" />
            </a>
          </div>
        </div>

        {/* Newsletter Section */}
        <div className="footer-section">
          <h3>Subscribe to Our Newsletter</h3>
          <Form layout="vertical" onFinish={handleSubmit} form={form} className="newsletter-form">
            <input
              type="email"
              placeholder="Enter your email"
              required
              className="newsletter-input"
            />
            <button type="submit" className="newsletter-button">
              Subscribe
            </button>
          </Form>
        </div>

        {/* Contact Information Section */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Email: <a href="mailto:info@Magdiam.com">Info@Magdiam.com</a></p>
          {/* <p>Phone: +1 (123) 456-7890</p>
          <p>Address: 123 Jewellery Lane, New York, USA</p> */}
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Magdiam. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;